class WindowNames
{
    static ASP = "ASP_WINDOW"
    static EID = "EID_WINDOW"
    static TID = "TID_WINDOW"
}

export { WindowNames }